var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.doctors),function(doctor,i){return _c('DoctorCard',{key:i,staticClass:"my-4",attrs:{"name":doctor.name,"image":doctor.image,"bio":doctor.bio,"isMobile":_vm.isMobile}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }